import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-toBottom",
  "use": "icon-toBottom-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-toBottom\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.263 860.723L162.821 163.887l348.442 214.41 348.407-214.41-348.407 696.836z\" p-id=\"7455\" fill=\"#f4ea2a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol